var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.000244141H27C29.7614 0.000244141 32 2.23882 32 5.00024V27.0002C32 29.7617 29.7614 32.0002 27 32.0002H5C2.23858 32.0002 0 29.7617 0 27.0002V5.00024C0 2.23882 2.23858 0.000244141 5 0.000244141ZM16.6919 12.0076C15.2589 12.6037 12.3949 13.8373 8.09992 15.7085C7.40248 15.9859 7.03714 16.2572 7.00388 16.5225C6.94767 16.9709 7.50915 17.1474 8.27374 17.3879C8.37774 17.4206 8.4855 17.4544 8.59598 17.4904C9.34822 17.7349 10.3601 18.0209 10.8862 18.0323C11.3633 18.0426 11.8959 17.8459 12.4839 17.4421C16.4968 14.7333 18.5683 13.3641 18.6983 13.3346C18.7901 13.3138 18.9172 13.2876 19.0034 13.3642C19.0895 13.4408 19.0811 13.5858 19.0719 13.6247C19.0163 13.8618 16.8123 15.9108 15.6717 16.9712C15.3161 17.3018 15.0639 17.5363 15.0124 17.5898C14.8969 17.7098 14.7791 17.8233 14.666 17.9323C13.9672 18.606 13.4431 19.1112 14.695 19.9362C15.2967 20.3327 15.7781 20.6606 16.2584 20.9876C16.7829 21.3448 17.306 21.7011 17.9829 22.1448C18.1554 22.2579 18.3201 22.3753 18.4805 22.4896C19.0909 22.9248 19.6393 23.3158 20.3168 23.2534C20.7105 23.2172 21.1172 22.847 21.3237 21.743C21.8118 19.1337 22.7712 13.4803 22.9929 11.1507C23.0123 10.9466 22.9879 10.6854 22.9683 10.5707C22.9486 10.4561 22.9076 10.2927 22.7586 10.1717C22.582 10.0285 22.3095 9.9983 22.1877 10.0003C21.6335 10.0102 20.7834 10.3058 16.6919 12.0076Z",
    fill: "#E2E2E2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.773f65f385574bf4d2f4e84db23a7d14.svg";
export { ForwardRef as ReactComponent };